// extracted by mini-css-extract-plugin
export default {"imageWrapper":"WW-z","videoWrapper":"XW-z","twoColumnImage":"YW-z","imageCarouselBtn":"ZW-z","carouselNextBtn":"_W-z","carouselPrevBtn":"aX-z"};